/* GENERATED by packages/tokens/scripts/build.ts. Do not edit: change tokens/*.json and run the build. */
/* eslint-disable */

export const THEMES = [
  {
    "name": "dark",
    "label": "Dark",
    "colorScheme": "dark",
    "order": 0
  },
  {
    "name": "light",
    "label": "Light",
    "colorScheme": "light",
    "order": 1
  },
  {
    "name": "high-contrast",
    "label": "High contrast",
    "colorScheme": "dark",
    "order": 2
  }
] as const;

export const DENSITIES = [
  {
    "name": "comfortable",
    "label": "Comfortable",
    "order": 0
  },
  {
    "name": "compact",
    "label": "Compact",
    "order": 1
  }
] as const;

/** Every semantic, theme, density and component token: CSS variable, tier, type and resolved value per mode. */
export const TOKENS = {
  "color.bg.default": {
    "css": "--bg",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#0a0b0d",
      "light": "#f3f4f7",
      "high-contrast": "#000000"
    },
    "description": "The canvas behind everything."
  },
  "color.bg.rail": {
    "css": "--bg-rail",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#0a0b0d",
      "light": "#eceef2",
      "high-contrast": "#000000"
    },
    "description": "The frame: the rail and the gutter around the content sheet, a step darker than the sheet so the content reads as one raised plane."
  },
  "color.surface.default": {
    "css": "--surface",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#121317",
      "light": "#ffffff",
      "high-contrast": "#0c0c0e"
    },
    "description": "Cards, panels, lists."
  },
  "color.surface.raised": {
    "css": "--surface-raised",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#1a1b20",
      "light": "#ffffff",
      "high-contrast": "#18191b"
    },
    "description": "Menus, popovers, dialogs: things above a surface."
  },
  "color.surface.sunken": {
    "css": "--surface-sunken",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#0a0b0d",
      "light": "#f2f3f6",
      "high-contrast": "#000000"
    },
    "description": "Wells inside a panel: board columns, code blocks."
  },
  "color.surface.hover": {
    "css": "--surface-hover",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#18191e",
      "light": "#eef0f4",
      "high-contrast": "#212225"
    },
    "description": "Hovered rows and controls."
  },
  "color.surface.active": {
    "css": "--surface-active",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#202227",
      "light": "#e7e9ee",
      "high-contrast": "#2e3135"
    },
    "description": "Pressed and selected rows; meter tracks."
  },
  "color.overlay.backdrop": {
    "css": "--overlay-backdrop",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#0404069e",
      "light": "#14141c52",
      "high-contrast": "#000000c7"
    }
  },
  "color.border.subtle": {
    "css": "--border-subtle",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#191a1e",
      "light": "#ebedf1",
      "high-contrast": "#7c8088"
    },
    "description": "Separators, only where a line carries meaning (a table header, a split between unlike things). Rows and tiles are grouped by space and surface, not lines. Decorative."
  },
  "color.border.default": {
    "css": "--border",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#1f2125",
      "light": "#e1e4ea",
      "high-contrast": "#8e929a"
    },
    "description": "Quiet edges of panels and overlays. Decorative."
  },
  "color.border.strong": {
    "css": "--border-strong",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#2c2f36",
      "light": "#cbced6",
      "high-contrast": "#ced1d6"
    },
    "description": "Hover edges, emphasis."
  },
  "color.border.control": {
    "css": "--border-control",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#6a6e78",
      "light": "#7c808a",
      "high-contrast": "#8e929a"
    },
    "description": "Edges of inputs, checkboxes, switches and selects: 3:1 on every surface (WCAG 1.4.11)."
  },
  "color.fg.default": {
    "css": "--fg",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#dfe1e6",
      "light": "#1e2229",
      "high-contrast": "#ffffff"
    },
    "description": "Primary text."
  },
  "color.fg.muted": {
    "css": "--fg-muted",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#a3a8b1",
      "light": "#4b515c",
      "high-contrast": "#dbdee3"
    },
    "description": "Secondary text."
  },
  "color.fg.subtle": {
    "css": "--fg-subtle",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#878b95",
      "light": "#5d616b",
      "high-contrast": "#ced1d6"
    },
    "description": "Meta text, timestamps, units, placeholders, neutral status."
  },
  "color.fg.faint": {
    "css": "--fg-faint",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#4d515a",
      "light": "#b3b7c0",
      "high-contrast": "#7c8088"
    },
    "description": "Disabled controls only. Never for text someone must read."
  },
  "color.accent.default": {
    "css": "--accent",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#789bff",
      "light": "#3a5fe6",
      "high-contrast": "#a6b8ff"
    },
    "description": "Brand accent: primary actions, focus, selection. Never a status."
  },
  "color.accent.hover": {
    "css": "--accent-hover",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#8aa9ff",
      "light": "#3456d8",
      "high-contrast": "#cbd5ff"
    }
  },
  "color.accent.active": {
    "css": "--accent-active",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#6a8ef6",
      "light": "#2f4fc8",
      "high-contrast": "#cbd5ff"
    },
    "description": "A pressed primary button: one step deeper than hover."
  },
  "color.accent.fg": {
    "css": "--accent-fg",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#08111f",
      "light": "#ffffff",
      "high-contrast": "#000000"
    },
    "description": "Text on an accent fill."
  },
  "color.accent.text": {
    "css": "--accent-text",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#94b6ff",
      "light": "#2f5ad6",
      "high-contrast": "#cbd5ff"
    },
    "description": "Accent-coloured text and links on a surface."
  },
  "color.focus.default": {
    "css": "--focus",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#8b93f8",
      "light": "#4b53d6",
      "high-contrast": "#ffd60a"
    },
    "description": "Focus rings: one solid indigo facet, so focus on the blue primary is unmistakable. Never a gradient."
  },
  "color.control.from": {
    "css": "--control-from",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#2c6ae8",
      "light": "#2862e2",
      "high-contrast": "#a6b8ff"
    },
    "description": "The top stop of the control gradient."
  },
  "color.control.to": {
    "css": "--control-to",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#3c5fdf",
      "light": "#3053d5",
      "high-contrast": "#a6b8ff"
    },
    "description": "The bottom stop of the control gradient."
  },
  "color.control.from-hover": {
    "css": "--control-from-hover",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#326feb",
      "light": "#3368e6",
      "high-contrast": "#cbd5ff"
    }
  },
  "color.control.to-hover": {
    "css": "--control-to-hover",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#4264e3",
      "light": "#3659d9",
      "high-contrast": "#cbd5ff"
    }
  },
  "color.control.from-active": {
    "css": "--control-from-active",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#2660df",
      "light": "#2558d0",
      "high-contrast": "#cbd5ff"
    }
  },
  "color.control.to-active": {
    "css": "--control-to-active",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#3454d5",
      "light": "#2d4abe",
      "high-contrast": "#cbd5ff"
    }
  },
  "color.control.mid": {
    "css": "--control-mid",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#3465e4",
      "light": "#2c5bdc",
      "high-contrast": "#a6b8ff"
    },
    "description": "The gradient at its middle: the solid fill of an on checkbox or switch (at 16 px two close stops would only read as banding) and the fallback under the gradient."
  },
  "color.control.line": {
    "css": "--control-line",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#5683f2",
      "light": "#2c5bdc",
      "high-contrast": "#a6b8ff"
    },
    "description": "A 2 px indicator: the tab underline, the selected segment, the selected bar. 3:1 on every surface it sits on."
  },
  "color.control.fg": {
    "css": "--control-fg",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#ffffff",
      "light": "#ffffff",
      "high-contrast": "#000000"
    },
    "description": "Text, checks and icons on the control fill: white, 4.5:1 on every stop."
  },
  "color.control.gradient": {
    "css": "--control-gradient",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #2c6ae8 0%, #3c5fdf 100%)",
      "light": "linear-gradient(180deg, #2862e2 0%, #3053d5 100%)",
      "high-contrast": "linear-gradient(180deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "The primary button and both halves of a split button: blue into royal, top to bottom, one continuous fill."
  },
  "color.control.gradient-hover": {
    "css": "--control-gradient-hover",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #326feb 0%, #4264e3 100%)",
      "light": "linear-gradient(180deg, #3368e6 0%, #3659d9 100%)",
      "high-contrast": "linear-gradient(180deg, #cbd5ff 0%, #cbd5ff 100%)"
    }
  },
  "color.control.gradient-active": {
    "css": "--control-gradient-active",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #2660df 0%, #3454d5 100%)",
      "light": "linear-gradient(180deg, #2558d0 0%, #2d4abe 100%)",
      "high-contrast": "linear-gradient(180deg, #cbd5ff 0%, #cbd5ff 100%)"
    }
  },
  "color.prism.from": {
    "css": "--prism-from",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#9c9afc",
      "light": "#5148d8",
      "high-contrast": "#a6b8ff"
    },
    "description": "First stop of the act gradient (the indigo facet): at least 30 degrees from every status hue."
  },
  "color.prism.to": {
    "css": "--prism-to",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#7ab2f0",
      "light": "#2367c6",
      "high-contrast": "#a6b8ff"
    },
    "description": "The sky stop: at least 15 degrees from working cyan, and only ever after a first stop."
  },
  "color.prism.from-hover": {
    "css": "--prism-from-hover",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#aaa8ff",
      "light": "#4339c6",
      "high-contrast": "#a6b8ff"
    }
  },
  "color.prism.to-hover": {
    "css": "--prism-to-hover",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#8cc0f4",
      "light": "#1a58ab",
      "high-contrast": "#a6b8ff"
    }
  },
  "color.prism.from-active": {
    "css": "--prism-from-active",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#8d8bf0",
      "light": "#3a31b0",
      "high-contrast": "#a6b8ff"
    }
  },
  "color.prism.to-active": {
    "css": "--prism-to-active",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#69a3e2",
      "light": "#164c94",
      "high-contrast": "#a6b8ff"
    }
  },
  "color.prism.gradient": {
    "css": "--prism-gradient",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(100deg, #9c9afc 0%, #7f98ff 36%, #7ab2f0 74%, #f1aa7c 92%, #ee9a6e 100%)",
      "light": "linear-gradient(100deg, #5148d8 0%, #3d5ce4 38%, #2367c6 80%, #b84d10 95%, #b04a0e 100%)",
      "high-contrast": "linear-gradient(100deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "The multicolour ray for brand art: indigo through blue and sky into a short warm exit. Never on a control or an indicator (21 Oct 2026)."
  },
  "color.prism.gradient-hover": {
    "css": "--prism-gradient-hover",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(100deg, #aaa8ff 0%, #8fa6ff 36%, #8cc0f4 74%, #f4b98f 92%, #f1aa80 100%)",
      "light": "linear-gradient(100deg, #4339c6 0%, #3049c8 38%, #1a58ab 80%, #a8440a 95%, #9c3f0a 100%)",
      "high-contrast": "linear-gradient(100deg, #a6b8ff 0%, #a6b8ff 100%)"
    }
  },
  "color.prism.gradient-active": {
    "css": "--prism-gradient-active",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(100deg, #8d8bf0 0%, #7088f2 36%, #69a3e2 74%, #e89a6e 92%, #e48d60 100%)",
      "light": "linear-gradient(100deg, #3a31b0 0%, #2a40b0 38%, #164c94 80%, #93390a 95%, #8a3609 100%)",
      "high-contrast": "linear-gradient(100deg, #a6b8ff 0%, #a6b8ff 100%)"
    }
  },
  "color.prism.progress": {
    "css": "--prism-progress",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(90deg, #6a8ef6 0%, #80aef7 100%)",
      "light": "linear-gradient(90deg, #2f4fc8 0%, #2f6ad6 100%)",
      "high-contrast": "linear-gradient(100deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "Progress and meters at an ok level: bluer than the button, because the bars sit beside cyan working bars."
  },
  "color.prism.wash": {
    "css": "--prism-wash",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(90deg, #5683f224 0%, #5683f214 50%, #5683f20b 100%)",
      "light": "linear-gradient(90deg, #2c5bdc1a 0%, #2c5bdc11 50%, #2c5bdc0a 100%)",
      "high-contrast": "linear-gradient(90deg, #a6b8ff29 0%, #a6b8ff29 100%)"
    },
    "description": "The selected look's wash (selected rows, the active nav item, the selected segment): the control line colour falling across the row, one hue fading at very low alpha. Text on it holds 4.5:1."
  },
  "color.prism.bar": {
    "css": "--prism-bar",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #5683f2 0%, #5683f2 100%)",
      "light": "linear-gradient(180deg, #2c5bdc 0%, #2c5bdc 100%)",
      "high-contrast": "linear-gradient(180deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "The selected look's 2 px leading bar: the control line colour, one hue. 3:1 on the wash it sits on."
  },
  "color.prism.headline": {
    "css": "--prism-headline",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(90deg, #94b6ff 0%, #aaa6f8 55%, #f2a27a 100%)",
      "light": "linear-gradient(90deg, #2f5ad6 0%, #5a48d6 55%, #b94a0c 100%)",
      "high-contrast": "linear-gradient(90deg, #cbd5ff 0%, #cbd5ff 100%)"
    },
    "description": "Brand emphasis text: the Overview headline words and the featured figure of each glance strip. Accent text through the indigo facet into a warm orange tail, every stop 4.5:1 on the canvas and the panel."
  },
  "color.prism.warm-glow": {
    "css": "--prism-warm-glow",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#f6ae5f57",
      "light": "#f6ae5f6b",
      "high-contrast": "#00000000"
    },
    "description": "The warm exit glow under the trailing edge of a hovered primary (console and site): amber light leaving the prism. Never a solid fill or a small mark."
  },
  "color.prism.new": {
    "css": "--prism-new",
    "tier": "theme",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(100deg, #f2bb9c 0%, #ec9f78 100%)",
      "light": "linear-gradient(100deg, #fbdccb 0%, #f8d2bd 100%)",
      "high-contrast": "linear-gradient(100deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "A New marker chip: the warm side, at most once per view."
  },
  "color.prism.new-fg": {
    "css": "--prism-new-fg",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#241205",
      "light": "#6a3517",
      "high-contrast": "#000000"
    }
  },
  "color.status.working": {
    "css": "--status-working",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#6fcde0",
      "light": "#05718a",
      "high-contrast": "#4ccce6"
    },
    "description": "Running. Icon: spinner ring. Icon colour and plain label."
  },
  "color.status.attention": {
    "css": "--status-attention",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#efc46a",
      "light": "#915b02",
      "high-contrast": "#ffca16"
    },
    "description": "Needs you: waiting on a human decision. Icon: hand. Icon colour and plain label."
  },
  "color.status.success": {
    "css": "--status-success",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#73cf9d",
      "light": "#07764b",
      "high-contrast": "#3dd68c"
    },
    "description": "Done: finished cleanly. Icon: check. Icon colour and plain label."
  },
  "color.status.danger": {
    "css": "--status-danger",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#f29c97",
      "light": "#c7232b",
      "high-contrast": "#ff9592"
    },
    "description": "Failed: error or blocked. Icon: x-circle. Icon colour and plain label."
  },
  "color.status.muted": {
    "css": "--status-muted",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#878b95",
      "light": "#5d616b",
      "high-contrast": "#ced1d6"
    },
    "description": "Idle, offline, paused. Icon: hollow dot or pause. Same colour as every neutral state: the icon tells them apart."
  },
  "color.status.pending": {
    "css": "--status-pending",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#878b95",
      "light": "#5d616b",
      "high-contrast": "#ced1d6"
    },
    "description": "Queued: accepted, not started. Icon: clock."
  },
  "color.status.inactive": {
    "css": "--status-inactive",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#878b95",
      "light": "#5d616b",
      "high-contrast": "#ced1d6"
    },
    "description": "Ended: no longer running, nothing wrong. Icon: minus-circle."
  },
  "color.status.working-soft": {
    "css": "--status-working-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#082c36",
      "light": "#def7f9",
      "high-contrast": "#00000000"
    },
    "description": "Soft pill background."
  },
  "color.status.attention-soft": {
    "css": "--status-attention-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#302008",
      "light": "#fff7c2",
      "high-contrast": "#00000000"
    },
    "description": "Soft pill background."
  },
  "color.status.success-soft": {
    "css": "--status-success-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#132d21",
      "light": "#e6f6eb",
      "high-contrast": "#00000000"
    },
    "description": "Soft pill background."
  },
  "color.status.danger-soft": {
    "css": "--status-danger-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#3b1219",
      "light": "#feebec",
      "high-contrast": "#00000000"
    },
    "description": "Soft pill background."
  },
  "color.status.muted-soft": {
    "css": "--status-muted-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#18191e",
      "light": "#eef0f4",
      "high-contrast": "#00000000"
    }
  },
  "color.status.pending-soft": {
    "css": "--status-pending-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#18191e",
      "light": "#eef0f4",
      "high-contrast": "#00000000"
    }
  },
  "color.status.inactive-soft": {
    "css": "--status-inactive-soft",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#18191e",
      "light": "#eef0f4",
      "high-contrast": "#00000000"
    }
  },
  "color.status.working-line": {
    "css": "--status-working-line",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#12677e",
      "light": "#7dcedc",
      "high-contrast": "#4ccce6"
    },
    "description": "Pill outline."
  },
  "color.status.attention-line": {
    "css": "--status-attention-line",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#714f19",
      "light": "#e9c162",
      "high-contrast": "#ffca16"
    },
    "description": "Pill outline."
  },
  "color.status.success-line": {
    "css": "--status-success-line",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#28684a",
      "light": "#8eceaa",
      "high-contrast": "#3dd68c"
    },
    "description": "Pill outline."
  },
  "color.status.danger-line": {
    "css": "--status-danger-line",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#8c333a",
      "light": "#f4a9aa",
      "high-contrast": "#ff9592"
    },
    "description": "Pill outline."
  },
  "color.status.working-ink": {
    "css": "--status-working-ink",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#b6ecf7",
      "light": "#0d3c48",
      "high-contrast": "#4ccce6"
    },
    "description": "Text inside a soft pill."
  },
  "color.status.attention-ink": {
    "css": "--status-attention-ink",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#ffe7b3",
      "light": "#4f3422",
      "high-contrast": "#ffca16"
    },
    "description": "Text inside a soft pill."
  },
  "color.status.success-ink": {
    "css": "--status-success-ink",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#b1f1cb",
      "light": "#193b2d",
      "high-contrast": "#3dd68c"
    },
    "description": "Text inside a soft pill."
  },
  "color.status.danger-ink": {
    "css": "--status-danger-ink",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#ffd1d9",
      "light": "#641723",
      "high-contrast": "#ff9592"
    },
    "description": "Text inside a soft pill."
  },
  "color.status.working-fill": {
    "css": "--status-working-fill",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#6fcde0",
      "light": "#5bb8cc",
      "high-contrast": "#4ccce6"
    },
    "description": "Bars, ticks and segments in this status: a soft fill, not the text colour."
  },
  "color.status.attention-fill": {
    "css": "--status-attention-fill",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#efc46a",
      "light": "#e6b24a",
      "high-contrast": "#ffca16"
    },
    "description": "Bars, ticks and segments in this status: a soft fill, not the text colour."
  },
  "color.status.success-fill": {
    "css": "--status-success-fill",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#73cf9d",
      "light": "#5fb886",
      "high-contrast": "#3dd68c"
    },
    "description": "Bars, ticks and segments in this status: a soft fill, not the text colour."
  },
  "color.status.danger-fill": {
    "css": "--status-danger-fill",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#f29c97",
      "light": "#e57f79",
      "high-contrast": "#ff9592"
    },
    "description": "Bars, ticks and segments in this status: a soft fill, not the text colour."
  },
  "color.data.1": {
    "css": "--data-1",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#7e97f1",
      "light": "#3354b6",
      "high-contrast": "#6686fd"
    }
  },
  "color.data.2": {
    "css": "--data-2",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#f9b787",
      "light": "#d17c3c",
      "high-contrast": "#fea76b"
    }
  },
  "color.data.3": {
    "css": "--data-3",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#83ecd9",
      "light": "#2b9c88",
      "high-contrast": "#0edabe"
    }
  },
  "color.data.4": {
    "css": "--data-4",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#d990c0",
      "light": "#b24f94",
      "high-contrast": "#feaff4"
    }
  },
  "color.data.5": {
    "css": "--data-5",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#71cae7",
      "light": "#2079a9",
      "high-contrast": "#03afcf"
    }
  },
  "color.data.6": {
    "css": "--data-6",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#f28f85",
      "light": "#c3463c",
      "high-contrast": "#f8554d"
    }
  },
  "color.data.7": {
    "css": "--data-7",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#d6c25a",
      "light": "#9a8628",
      "high-contrast": "#9f9600"
    }
  },
  "color.data.8": {
    "css": "--data-8",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#bd8ff5",
      "light": "#8d6bd6",
      "high-contrast": "#cc86fe"
    }
  },
  "color.live-trace": {
    "css": "--live-trace",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#a3a8b18c",
      "light": "#51555dbf",
      "high-contrast": "#dbdee3b3"
    },
    "description": "Live layer: an edge that carried work in the last 60 s (1.5 px). A mix of the secondary text colour; 3:1 on surface and canvas (tested)."
  },
  "color.live-trace-strong": {
    "css": "--live-trace-strong",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#a3a8b1",
      "light": "#51555d",
      "high-contrast": "#dbdee3"
    },
    "description": "Live layer: a flow dot (4 px), and the still twin of a busy edge under reduced motion."
  },
  "color.activity.0": {
    "css": "--activity-0",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#212225",
      "light": "#f0f0f3",
      "high-contrast": "#272a2d"
    }
  },
  "color.activity.1": {
    "css": "--activity-1",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#2e3135",
      "light": "#e0e1e6",
      "high-contrast": "#363a3f"
    }
  },
  "color.activity.2": {
    "css": "--activity-2",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#43484e",
      "light": "#cdced6",
      "high-contrast": "#5a6169"
    }
  },
  "color.activity.3": {
    "css": "--activity-3",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#696e77",
      "light": "#8b8d98",
      "high-contrast": "#777b84"
    }
  },
  "color.activity.4": {
    "css": "--activity-4",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#b0b4ba",
      "light": "#60646c",
      "high-contrast": "#dbdee3"
    }
  },
  "color.brand.prism-1": {
    "css": "--brand-prism-1",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#4e98ff",
      "light": "#4e98ff",
      "high-contrast": "#4e98ff"
    },
    "description": "Brand facet colours for the mark: never UI state."
  },
  "color.brand.prism-2": {
    "css": "--brand-prism-2",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#38c4ea",
      "light": "#38c4ea",
      "high-contrast": "#38c4ea"
    }
  },
  "color.brand.prism-3": {
    "css": "--brand-prism-3",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#f6ae5f",
      "light": "#f6ae5f",
      "high-contrast": "#f6ae5f"
    }
  },
  "color.brand.prism-4": {
    "css": "--brand-prism-4",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#ee8350",
      "light": "#ee8350",
      "high-contrast": "#ee8350"
    }
  },
  "color.brand.prism-5": {
    "css": "--brand-prism-5",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#5160ee",
      "light": "#5160ee",
      "high-contrast": "#5160ee"
    }
  },
  "color.brand.prism-6": {
    "css": "--brand-prism-6",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#3e6cf4",
      "light": "#3e6cf4",
      "high-contrast": "#3e6cf4"
    }
  },
  "color.brand.prism-shade": {
    "css": "--brand-prism-shade",
    "tier": "theme",
    "type": "color",
    "value": {
      "dark": "#0b1020",
      "light": "#0b1020",
      "high-contrast": "#0b1020"
    },
    "description": "The inner bevel of each facet, at 26% over its colour."
  },
  "elevation.1": {
    "css": "--elevation-1",
    "tier": "theme",
    "type": "shadow",
    "value": {
      "dark": "0px 1px 2px 0px #00000066, 0px 4px 12px 0px #00000047",
      "light": "0px 1px 2px 0px #1010180f, 0px 4px 12px 0px #1010180f",
      "high-contrast": "0px 0px 0px 1px #ffffff3d, 0px 4px 12px 0px #000000cc"
    },
    "description": "Menus, popovers, tooltips."
  },
  "elevation.2": {
    "css": "--elevation-2",
    "tier": "theme",
    "type": "shadow",
    "value": {
      "dark": "0px 2px 4px 0px #00000066, 0px 12px 32px 0px #00000073",
      "light": "0px 2px 4px 0px #1010180f, 0px 12px 32px 0px #1010181a",
      "high-contrast": "0px 0px 0px 1px #ffffff3d, 0px 12px 32px 0px #000000cc"
    },
    "description": "Drawers and toasts."
  },
  "elevation.3": {
    "css": "--elevation-3",
    "tier": "theme",
    "type": "shadow",
    "value": {
      "dark": "0px 0px 0px 1px #ffffff0f, 0px 16px 48px 0px #0000008c, 0px 4px 12px 0px #00000066",
      "light": "0px 0px 0px 1px #10101814, 0px 16px 48px 0px #10101829, 0px 4px 12px 0px #10101814",
      "high-contrast": "0px 0px 0px 1px #ffffff3d, 0px 16px 48px 0px #000000cc"
    },
    "description": "Dialogs and the command palette."
  },
  "elevation.flat": {
    "css": "--elevation-flat",
    "tier": "theme",
    "type": "shadow",
    "value": {
      "dark": "inset 0px 1px 0px 0px #ffffff0a, 0px 1px 2px 0px #00000047",
      "light": "0px 1px 4px 0px #1010180f, 0px 1px 1px 0px #1010180a",
      "high-contrast": "0px 1px 0px 0px #000000cc"
    },
    "description": "Resting panels and tiles: a 1 px top light and a soft contact shadow. Depth comes from the lighter surface, not a line."
  },
  "elevation.highlight": {
    "css": "--elevation-highlight",
    "tier": "theme",
    "type": "shadow",
    "value": {
      "dark": "inset 0px 1px 0px 0px #ffffff0a",
      "light": "inset 0px 1px 0px 0px #ffffff99",
      "high-contrast": "inset 0px 1px 0px 0px #ffffff0a"
    },
    "description": "The 1 px top light on a surface."
  },
  "row.height": {
    "css": "--row-height",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "40px",
      "compact": "32px"
    },
    "description": "One-line list or table row, the table header and the group header. One row height per list."
  },
  "row.height-2line": {
    "css": "--row-height-2line",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "56px",
      "compact": "48px"
    },
    "description": "Two-line row: title plus one meta line."
  },
  "row.padding-x": {
    "css": "--row-padding-x",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    },
    "description": "Row side padding."
  },
  "control.height": {
    "css": "--control-height",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "32px",
      "compact": "28px"
    },
    "description": "Default buttons, inputs, selects, segmented controls (control md)."
  },
  "control.height-xs": {
    "css": "--control-height-xs",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "24px",
      "compact": "24px"
    },
    "description": "Inline row actions only (icon buttons that appear on hover)."
  },
  "control.height-sm": {
    "css": "--control-height-sm",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "28px",
      "compact": "28px"
    },
    "description": "Buttons and inputs in filter bars and toolbars."
  },
  "control.height-lg": {
    "css": "--control-height-lg",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "40px",
      "compact": "32px"
    },
    "description": "Primary call to action in a dialog footer or empty state."
  },
  "control.padding-x": {
    "css": "--control-padding-x",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "12px",
      "compact": "8px"
    },
    "description": "Horizontal padding inside buttons and inputs."
  },
  "cell.gap": {
    "css": "--cell-gap",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    },
    "description": "Gap between columns in a row."
  },
  "menu-item.height": {
    "css": "--menu-item-height",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "32px",
      "compact": "28px"
    },
    "description": "Menu, select, command palette and nav items."
  },
  "timeline.lane-height": {
    "css": "--timeline-lane-height",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "32px",
      "compact": "28px"
    },
    "description": "One lane on the agents timeline."
  },
  "filter-bar.height": {
    "css": "--filter-bar-height",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "40px",
      "compact": "36px"
    },
    "description": "The filter and view bar under the page header."
  },
  "space.inset.card": {
    "css": "--space-inset-card",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    },
    "description": "Padding inside cards, panels and tiles."
  },
  "space.inset.drawer": {
    "css": "--space-inset-drawer",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "24px",
      "compact": "16px"
    },
    "description": "Padding inside drawers and sheets."
  },
  "space.stack.section": {
    "css": "--space-stack-section",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "32px",
      "compact": "24px"
    },
    "description": "Between sections of a page."
  },
  "space.stack.card": {
    "css": "--space-stack-card",
    "tier": "density",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    },
    "description": "Between cards in a grid or stack."
  },
  "font.sans": {
    "css": "--font-sans",
    "tier": "semantic",
    "type": "fontFamily",
    "value": "'Inter Variable', 'Inter Fallback', 'Segoe UI Variable Text', 'Segoe UI', system-ui, -apple-system, 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'Arial', sans-serif",
    "description": "UI text: Inter Variable, self-hosted (packages/tokens/fonts.css)."
  },
  "font.display": {
    "css": "--font-display",
    "tier": "semantic",
    "type": "fontFamily",
    "value": "'Inter Variable', 'Inter Display Fallback', 'Inter Fallback', 'Segoe UI Variable Display', 'Segoe UI', system-ui, -apple-system, 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'Arial', sans-serif",
    "description": "Headings at 20 px and up and big numbers (title, heading, display, metric, metric-sm): Inter Variable at its Display optical size, with a fallback matched to the Display widths."
  },
  "font.mono": {
    "css": "--font-mono",
    "tier": "semantic",
    "type": "fontFamily",
    "value": "'JetBrains Mono Variable', 'JetBrains Mono', 'Cascadia Code', ui-monospace, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace",
    "description": "Code, logs, IDs, hashes, branches, paths, commands: JetBrains Mono Variable. One size smaller than the sans text beside it."
  },
  "font-size.caption": {
    "css": "--font-size-caption",
    "tier": "semantic",
    "type": "dimension",
    "value": "11px",
    "description": "Secondary text, a clear step under the 13 px rows: meta lines, timestamps, labels over values, table headers, pill labels, helper text."
  },
  "font-size.ui": {
    "css": "--font-size-ui",
    "tier": "semantic",
    "type": "dimension",
    "value": "13px",
    "description": "The default: rows, menus, nav, buttons, inputs, table cells; code blocks in mono."
  },
  "font-size.body": {
    "css": "--font-size-body",
    "tier": "semantic",
    "type": "dimension",
    "value": "13px",
    "description": "Reading text: descriptions, forms, dialogs, empty-state sentences. The same size as ui, with room between lines; the hierarchy comes from colour and weight, not size."
  },
  "font-size.lead": {
    "css": "--font-size-lead",
    "tier": "semantic",
    "type": "dimension",
    "value": "15px",
    "description": "Panel and card titles, with their count at 400 fg-subtle; dialog section heads (title-3)."
  },
  "font-size.title": {
    "css": "--font-size-title",
    "tier": "semantic",
    "type": "dimension",
    "value": "20px",
    "description": "Drawer and dialog titles, settings section titles (title-2); font-display."
  },
  "font-size.heading": {
    "css": "--font-size-heading",
    "tier": "semantic",
    "type": "dimension",
    "value": "24px",
    "description": "The page title, one per page (title-1), with its count in the same size at 400 fg-subtle; font-display."
  },
  "font-size.display": {
    "css": "--font-size-display",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px",
    "description": "Rare: onboarding and first-use empty states; font-display."
  },
  "font-size.metric": {
    "css": "--font-size-metric",
    "tier": "semantic",
    "type": "dimension",
    "value": "28px",
    "description": "Stat tile values (StatTile, MetricTile): the numbers a page is about. Medium (500), num-display."
  },
  "font-size.metric-sm": {
    "css": "--font-size-metric-sm",
    "tier": "semantic",
    "type": "dimension",
    "value": "20px",
    "description": "Key figures in drawer and card facts (cost, tokens, duration). Medium (500), num-display."
  },
  "font-size.mono": {
    "css": "--font-size-mono",
    "tier": "semantic",
    "type": "dimension",
    "value": "12px",
    "description": "Mono in rows (ids, branches, hashes, model names): at 11 px JetBrains Mono's tall lowercase cramps beside 13 px Inter. Applied to font-mono text-caption by the console stylesheet; code blocks are 13 px (ui)."
  },
  "font-size.wall-caption": {
    "css": "--font-size-wall-caption",
    "tier": "semantic",
    "type": "dimension",
    "value": "24px",
    "description": "Wall only: meta text, timestamps, the date under the clock."
  },
  "font-size.wall-ui": {
    "css": "--font-size-wall-ui",
    "tier": "semantic",
    "type": "dimension",
    "value": "28px",
    "description": "Wall only: rows, labels and activity lines."
  },
  "font-size.wall-lead": {
    "css": "--font-size-wall-lead",
    "tier": "semantic",
    "type": "dimension",
    "value": "36px",
    "description": "Wall only: band titles and the spotlight's subject."
  },
  "font-size.wall-title": {
    "css": "--font-size-wall-title",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px",
    "description": "Wall only: KPI values."
  },
  "font-size.wall-display": {
    "css": "--font-size-wall-display",
    "tier": "semantic",
    "type": "dimension",
    "value": "72px",
    "description": "Wall only: the clock and the one hero number."
  },
  "font-size.wall-hero": {
    "css": "--font-size-wall-hero",
    "tier": "semantic",
    "type": "dimension",
    "value": "120px",
    "description": "Wall only: the empty and connecting states."
  },
  "line-height.caption": {
    "css": "--line-height-caption",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px"
  },
  "line-height.ui": {
    "css": "--line-height-ui",
    "tier": "semantic",
    "type": "dimension",
    "value": "20px"
  },
  "line-height.body": {
    "css": "--line-height-body",
    "tier": "semantic",
    "type": "dimension",
    "value": "20px"
  },
  "line-height.lead": {
    "css": "--line-height-lead",
    "tier": "semantic",
    "type": "dimension",
    "value": "20px"
  },
  "line-height.title": {
    "css": "--line-height-title",
    "tier": "semantic",
    "type": "dimension",
    "value": "28px"
  },
  "line-height.heading": {
    "css": "--line-height-heading",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px"
  },
  "line-height.display": {
    "css": "--line-height-display",
    "tier": "semantic",
    "type": "dimension",
    "value": "40px"
  },
  "line-height.metric": {
    "css": "--line-height-metric",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px",
    "description": "At least 1.14 x the size, so rolling digits never clip."
  },
  "line-height.metric-sm": {
    "css": "--line-height-metric-sm",
    "tier": "semantic",
    "type": "dimension",
    "value": "28px"
  },
  "line-height.mono": {
    "css": "--line-height-mono",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px"
  },
  "line-height.wall-caption": {
    "css": "--line-height-wall-caption",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px"
  },
  "line-height.wall-ui": {
    "css": "--line-height-wall-ui",
    "tier": "semantic",
    "type": "dimension",
    "value": "36px"
  },
  "line-height.wall-lead": {
    "css": "--line-height-wall-lead",
    "tier": "semantic",
    "type": "dimension",
    "value": "44px"
  },
  "line-height.wall-title": {
    "css": "--line-height-wall-title",
    "tier": "semantic",
    "type": "dimension",
    "value": "56px"
  },
  "line-height.wall-display": {
    "css": "--line-height-wall-display",
    "tier": "semantic",
    "type": "dimension",
    "value": "80px"
  },
  "line-height.wall-hero": {
    "css": "--line-height-wall-hero",
    "tier": "semantic",
    "type": "dimension",
    "value": "128px"
  },
  "letter-spacing.caption": {
    "css": "--letter-spacing-caption",
    "tier": "semantic",
    "type": "dimension",
    "value": "0em"
  },
  "letter-spacing.ui": {
    "css": "--letter-spacing-ui",
    "tier": "semantic",
    "type": "dimension",
    "value": "0em"
  },
  "letter-spacing.body": {
    "css": "--letter-spacing-body",
    "tier": "semantic",
    "type": "dimension",
    "value": "0em"
  },
  "letter-spacing.lead": {
    "css": "--letter-spacing-lead",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.009em"
  },
  "letter-spacing.title": {
    "css": "--letter-spacing-title",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.016em"
  },
  "letter-spacing.heading": {
    "css": "--letter-spacing-heading",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.021em"
  },
  "letter-spacing.display": {
    "css": "--letter-spacing-display",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.024em"
  },
  "letter-spacing.metric": {
    "css": "--letter-spacing-metric",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.024em"
  },
  "letter-spacing.metric-sm": {
    "css": "--letter-spacing-metric-sm",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.016em"
  },
  "letter-spacing.mono": {
    "css": "--letter-spacing-mono",
    "tier": "semantic",
    "type": "dimension",
    "value": "0em"
  },
  "letter-spacing.wall-caption": {
    "css": "--letter-spacing-wall-caption",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.01em"
  },
  "letter-spacing.wall-ui": {
    "css": "--letter-spacing-wall-ui",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.012em"
  },
  "letter-spacing.wall-lead": {
    "css": "--letter-spacing-wall-lead",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.015em"
  },
  "letter-spacing.wall-title": {
    "css": "--letter-spacing-wall-title",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.02em"
  },
  "letter-spacing.wall-display": {
    "css": "--letter-spacing-wall-display",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.025em"
  },
  "letter-spacing.wall-hero": {
    "css": "--letter-spacing-wall-hero",
    "tier": "semantic",
    "type": "dimension",
    "value": "-0.03em"
  },
  "font-weight.regular": {
    "css": "--font-weight-regular",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400"
  },
  "font-weight.medium": {
    "css": "--font-weight-medium",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "500",
    "description": "Row titles, active nav, button labels, column headers, group labels."
  },
  "font-weight.semibold": {
    "css": "--font-weight-semibold",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600",
    "description": "Titles and KPI values."
  },
  "font-weight.caption": {
    "css": "--font-weight-caption",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400"
  },
  "font-weight.ui": {
    "css": "--font-weight-ui",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400"
  },
  "font-weight.body": {
    "css": "--font-weight-body",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400"
  },
  "font-weight.lead": {
    "css": "--font-weight-lead",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "font-weight.title": {
    "css": "--font-weight-title",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "font-weight.heading": {
    "css": "--font-weight-heading",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "font-weight.display": {
    "css": "--font-weight-display",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "font-weight.metric": {
    "css": "--font-weight-metric",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "500",
    "description": "500, not 600: at 28 px with Display shapes, Medium is crisp; Semibold goes loud on dark, and words (titles at 600) and numbers do not compete."
  },
  "font-weight.metric-sm": {
    "css": "--font-weight-metric-sm",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "500"
  },
  "font-weight.mono": {
    "css": "--font-weight-mono",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400"
  },
  "font-weight.wall-caption": {
    "css": "--font-weight-wall-caption",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400"
  },
  "font-weight.wall-ui": {
    "css": "--font-weight-wall-ui",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "400",
    "description": "A label that leads a row takes medium (500)."
  },
  "font-weight.wall-lead": {
    "css": "--font-weight-wall-lead",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "500"
  },
  "font-weight.wall-title": {
    "css": "--font-weight-wall-title",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "font-weight.wall-display": {
    "css": "--font-weight-wall-display",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "font-weight.wall-hero": {
    "css": "--font-weight-wall-hero",
    "tier": "semantic",
    "type": "fontWeight",
    "value": "600"
  },
  "space.0": {
    "css": "--space-0",
    "tier": "semantic",
    "type": "dimension",
    "value": "0px"
  },
  "space.1": {
    "css": "--space-1",
    "tier": "semantic",
    "type": "dimension",
    "value": "4px"
  },
  "space.2": {
    "css": "--space-2",
    "tier": "semantic",
    "type": "dimension",
    "value": "8px"
  },
  "space.3": {
    "css": "--space-3",
    "tier": "semantic",
    "type": "dimension",
    "value": "12px"
  },
  "space.4": {
    "css": "--space-4",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px"
  },
  "space.6": {
    "css": "--space-6",
    "tier": "semantic",
    "type": "dimension",
    "value": "24px"
  },
  "space.8": {
    "css": "--space-8",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px"
  },
  "space.12": {
    "css": "--space-12",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px"
  },
  "space.16": {
    "css": "--space-16",
    "tier": "semantic",
    "type": "dimension",
    "value": "64px"
  },
  "space.inline.xs": {
    "css": "--space-inline-xs",
    "tier": "semantic",
    "type": "dimension",
    "value": "4px",
    "description": "Icon to text in 24 px controls; between chips."
  },
  "space.inline.sm": {
    "css": "--space-inline-sm",
    "tier": "semantic",
    "type": "dimension",
    "value": "6px",
    "description": "Icon to label in 28 and 32 px controls. Component internal."
  },
  "space.inline.md": {
    "css": "--space-inline-md",
    "tier": "semantic",
    "type": "dimension",
    "value": "8px",
    "description": "Between buttons in a toolbar or footer."
  },
  "space.inset.control": {
    "css": "--space-inset-control",
    "tier": "semantic",
    "type": "dimension",
    "value": {
      "comfortable": "12px",
      "compact": "8px"
    },
    "description": "Horizontal padding inside inputs and buttons (follows density)."
  },
  "space.inset.dialog": {
    "css": "--space-inset-dialog",
    "tier": "semantic",
    "type": "dimension",
    "value": "24px",
    "description": "Padding inside dialogs."
  },
  "space.inset.popover": {
    "css": "--space-inset-popover",
    "tier": "semantic",
    "type": "dimension",
    "value": "4px",
    "description": "Padding around the items of a menu or popover list."
  },
  "space.inset.page": {
    "css": "--space-inset-page",
    "tier": "semantic",
    "type": "dimension",
    "value": "24px",
    "description": "Gutter around page content from 768 px to 1919 px."
  },
  "space.inset.page-phone": {
    "css": "--space-inset-page-phone",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px",
    "description": "Gutter below 768 px."
  },
  "space.inset.page-wide": {
    "css": "--space-inset-page-wide",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px",
    "description": "Gutter from 1920 px."
  },
  "space.stack.tight": {
    "css": "--space-stack-tight",
    "tier": "semantic",
    "type": "dimension",
    "value": "4px",
    "description": "Between a label and its value."
  },
  "space.stack.default": {
    "css": "--space-stack",
    "tier": "semantic",
    "type": "dimension",
    "value": "8px",
    "description": "Between related items."
  },
  "space.stack.group": {
    "css": "--space-stack-group",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px",
    "description": "Between groups inside a section; from a page title to the first content."
  },
  "radius.control": {
    "css": "--radius-control",
    "tier": "semantic",
    "type": "dimension",
    "value": "6px",
    "description": "Buttons, inputs, selects, segmented controls, menu items, chips, tags, kbd, focus rings on controls."
  },
  "radius.card": {
    "css": "--radius-card",
    "tier": "semantic",
    "type": "dimension",
    "value": "8px",
    "description": "Cards, panels, tiles, menus, popovers, board columns, attachment tiles."
  },
  "radius.overlay": {
    "css": "--radius-overlay",
    "tier": "semantic",
    "type": "dimension",
    "value": "12px",
    "description": "Dialogs, drawers, the command palette."
  },
  "radius.pill": {
    "css": "--radius-pill",
    "tier": "semantic",
    "type": "dimension",
    "value": "9999px",
    "description": "Status pills, dots, meters, avatars."
  },
  "duration.fast": {
    "css": "--duration-fast",
    "tier": "semantic",
    "type": "duration",
    "value": "120ms",
    "description": "Hover, press, and every exit."
  },
  "duration.base": {
    "css": "--duration-base",
    "tier": "semantic",
    "type": "duration",
    "value": "200ms",
    "description": "Entering menus, popovers, dialogs; live values easing in."
  },
  "duration.slow": {
    "css": "--duration-slow",
    "tier": "semantic",
    "type": "duration",
    "value": "320ms",
    "description": "Drawers and page-level transitions."
  },
  "duration.highlight": {
    "css": "--duration-highlight",
    "tier": "semantic",
    "type": "duration",
    "value": "600ms",
    "description": "The soft highlight on a live row that changed."
  },
  "duration.tick": {
    "css": "--duration-tick",
    "tier": "semantic",
    "type": "duration",
    "value": "1000ms",
    "description": "M1 drift: one step of a lane group on the shared 1 s clock. Reduced motion: no drift; lanes step every 5 s."
  },
  "duration.number": {
    "css": "--duration-number",
    "tier": "semantic",
    "type": "duration",
    "value": "400ms",
    "description": "M3 digit roll in LiveNumber. Reduced motion: the value snaps, plus the cell tint marker."
  },
  "duration.flow": {
    "css": "--duration-flow",
    "tier": "semantic",
    "type": "duration",
    "value": "1600ms",
    "description": "M5 flow dot travelling one edge. Reduced motion: no dots; the edge turns live-trace-strong with a rate label."
  },
  "duration.moment": {
    "css": "--duration-moment",
    "tier": "semantic",
    "type": "duration",
    "value": "1200ms",
    "description": "M13: one whole moment (Wait, Fail, Land, Catch). Reduced motion: a static icon plus label for 5 s."
  },
  "duration.spin": {
    "css": "--duration-spin",
    "tier": "semantic",
    "type": "duration",
    "value": "800ms",
    "description": "M10: one turn of the working spinner. Reduced motion: a static ring."
  },
  "duration.stripe": {
    "css": "--duration-stripe",
    "tier": "semantic",
    "type": "duration",
    "value": "1200ms",
    "description": "M11: one pass of the indeterminate stripe on a progress bar. Reduced motion: a static 40% fill and the words In progress."
  },
  "duration.shimmer": {
    "css": "--duration-shimmer",
    "tier": "semantic",
    "type": "duration",
    "value": "1600ms",
    "description": "One pass of the skeleton shimmer. Reduced motion: no shimmer."
  },
  "duration.fade-reduced": {
    "css": "--duration-fade-reduced",
    "tier": "semantic",
    "type": "duration",
    "value": "120ms",
    "description": "The opacity fade that stands in for movement under reduced motion (root crossfade, row to drawer, arrivals). Kept under reduced motion: opacity only, never position."
  },
  "easing.standard": {
    "css": "--easing-standard",
    "tier": "semantic",
    "type": "cubicBezier",
    "value": "cubic-bezier(0.16, 1, 0.3, 1)",
    "description": "Default: things arriving or responding."
  },
  "easing.emphasized": {
    "css": "--easing-emphasized",
    "tier": "semantic",
    "type": "cubicBezier",
    "value": "cubic-bezier(0.65, 0, 0.35, 1)",
    "description": "Larger moves: drawers, page transitions."
  },
  "easing.linear": {
    "css": "--easing-linear",
    "tier": "semantic",
    "type": "cubicBezier",
    "value": "linear",
    "description": "Time itself: drift (M1), flow dots (M5), spinners and stripes. Never for a move the user caused."
  },
  "easing.settle": {
    "css": "--easing-settle",
    "tier": "semantic",
    "type": "cubicBezier",
    "value": "linear(0, 0.0229, 0.0789, 0.1534, 0.2364, 0.3211, 0.4034, 0.4806, 0.5514, 0.615, 0.6715, 0.7211, 0.7642, 0.8014, 0.8332, 0.8604, 0.8835, 0.903, 0.9194, 0.9331, 0.9447, 0.9543, 0.9623, 0.9689, 0.9744, 0.979, 0.9828, 0.9859, 0.9884, 0.9905, 0.9923, 0.9937, 0.9948, 0.9958, 0.9966, 0.9972, 0.9977, 0.9981, 0.9985, 0.9988, 1)",
    "description": "A critically damped spring as CSS linear(): digit rolls (M3), stage handoffs (M6), meter fills. No bounce, no overshoot."
  },
  "density.wall.row": {
    "css": "--density-wall-row",
    "tier": "semantic",
    "type": "dimension",
    "value": "72px",
    "description": "One wall row: an agent, a landing, a needs-you item."
  },
  "density.wall.control": {
    "css": "--density-wall-control",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px",
    "description": "The few wall controls: pause, exit, playlist."
  },
  "density.wall.icon": {
    "css": "--density-wall-icon",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px",
    "description": "Status and kind icons on the wall."
  },
  "density.wall.gap-sm": {
    "css": "--density-wall-gap-sm",
    "tier": "semantic",
    "type": "dimension",
    "value": "24px",
    "description": "Inside a band: between a row's cells."
  },
  "density.wall.gap-md": {
    "css": "--density-wall-gap-md",
    "tier": "semantic",
    "type": "dimension",
    "value": "32px",
    "description": "Between rows and tiles."
  },
  "density.wall.gap-lg": {
    "css": "--density-wall-gap-lg",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px",
    "description": "Between bands, and the screen-edge gutter."
  },
  "density.wall.status-dot": {
    "css": "--density-wall-status-dot",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px",
    "description": "Identity and presence dots on the wall."
  },
  "layout.rail-width": {
    "css": "--layout-rail-width",
    "tier": "semantic",
    "type": "dimension",
    "value": "224px"
  },
  "layout.rail-width-collapsed": {
    "css": "--layout-rail-width-collapsed",
    "tier": "semantic",
    "type": "dimension",
    "value": "56px"
  },
  "layout.topbar-height": {
    "css": "--layout-topbar-height",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px"
  },
  "layout.page-header-height": {
    "css": "--layout-page-header-height",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px",
    "description": "Title row with the one primary action."
  },
  "layout.width-interstitial": {
    "css": "--layout-width-interstitial",
    "tier": "semantic",
    "type": "dimension",
    "value": "400px",
    "description": "Sign-in, connect a machine."
  },
  "layout.width-form": {
    "css": "--layout-width-form",
    "tier": "semantic",
    "type": "dimension",
    "value": "640px",
    "description": "Single-column forms."
  },
  "layout.width-prose": {
    "css": "--layout-width-prose",
    "tier": "semantic",
    "type": "dimension",
    "value": "720px",
    "description": "Reading text: story bodies, spec previews, ADRs. About 70 characters a line."
  },
  "layout.width-detail": {
    "css": "--layout-width-detail",
    "tier": "semantic",
    "type": "dimension",
    "value": "1200px",
    "description": "Detail, record and settings pages."
  },
  "layout.width-dashboard": {
    "css": "--layout-width-dashboard",
    "tier": "semantic",
    "type": "dimension",
    "value": "1584px",
    "description": "Dashboards: centred beyond this; add columns instead of stretching cards."
  },
  "breakpoint.sm": {
    "css": "--breakpoint-sm",
    "tier": "semantic",
    "type": "dimension",
    "value": "40rem",
    "description": "640: phone landscape."
  },
  "breakpoint.md": {
    "css": "--breakpoint-md",
    "tier": "semantic",
    "type": "dimension",
    "value": "48rem",
    "description": "768: below this is the phone layout (bottom nav, 44 px targets, sheets)."
  },
  "breakpoint.lg": {
    "css": "--breakpoint-lg",
    "tier": "semantic",
    "type": "dimension",
    "value": "64rem",
    "description": "1024: rail collapses to icons by default."
  },
  "breakpoint.xl": {
    "css": "--breakpoint-xl",
    "tier": "semantic",
    "type": "dimension",
    "value": "80rem",
    "description": "1280: full rail; list plus overlay drawer."
  },
  "breakpoint.2xl": {
    "css": "--breakpoint-2xl",
    "tier": "semantic",
    "type": "dimension",
    "value": "90rem",
    "description": "1440: the drawer docks as a split pane."
  },
  "breakpoint.3xl": {
    "css": "--breakpoint-3xl",
    "tier": "semantic",
    "type": "dimension",
    "value": "120rem",
    "description": "1920: list, detail and inspector; dashboards to four columns."
  },
  "touch.target": {
    "css": "--touch-target",
    "tier": "semantic",
    "type": "dimension",
    "value": "44px",
    "description": "Minimum hit area for anything tappable."
  },
  "touch.row-height": {
    "css": "--touch-row-height",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px",
    "description": "One-line rows."
  },
  "touch.row-height-2line": {
    "css": "--touch-row-height-2line",
    "tier": "semantic",
    "type": "dimension",
    "value": "64px",
    "description": "Two-line rows (the phone default)."
  },
  "touch.control-lg": {
    "css": "--touch-control-lg",
    "tier": "semantic",
    "type": "dimension",
    "value": "48px",
    "description": "Primary call to action on a sheet."
  },
  "touch.bottom-nav-height": {
    "css": "--touch-bottom-nav-height",
    "tier": "semantic",
    "type": "dimension",
    "value": "56px"
  },
  "touch.input-font": {
    "css": "--touch-input-font",
    "tier": "semantic",
    "type": "dimension",
    "value": "16px",
    "description": "Inputs never below 16 px on a phone (stops iOS zoom)."
  },
  "z.base": {
    "css": "--z-base",
    "tier": "semantic",
    "type": "number",
    "value": "0"
  },
  "z.sticky": {
    "css": "--z-sticky",
    "tier": "semantic",
    "type": "number",
    "value": "10"
  },
  "z.rail": {
    "css": "--z-rail",
    "tier": "semantic",
    "type": "number",
    "value": "20"
  },
  "z.dropdown": {
    "css": "--z-dropdown",
    "tier": "semantic",
    "type": "number",
    "value": "55",
    "description": "Menus, selects and popovers: above dialogs (overlay), so a list opened inside a dialog shows on top of it"
  },
  "z.overlay": {
    "css": "--z-overlay",
    "tier": "semantic",
    "type": "number",
    "value": "50"
  },
  "z.toast": {
    "css": "--z-toast",
    "tier": "semantic",
    "type": "number",
    "value": "60"
  },
  "z.tooltip": {
    "css": "--z-tooltip",
    "tier": "semantic",
    "type": "number",
    "value": "70"
  },
  "color.accent.soft": {
    "css": "--accent-soft",
    "tier": "semantic",
    "type": "color",
    "value": {
      "dark": "#789bff29",
      "light": "#3a5fe629",
      "high-contrast": "#a6b8ff29"
    }
  },
  "color.accent.line": {
    "css": "--accent-line",
    "tier": "semantic",
    "type": "color",
    "value": {
      "dark": "#789bff66",
      "light": "#3a5fe666",
      "high-contrast": "#a6b8ff66"
    }
  },
  "color.accent.ring": {
    "css": "--accent-ring",
    "tier": "semantic",
    "type": "color",
    "value": {
      "dark": "#789bff40",
      "light": "#3a5fe640",
      "high-contrast": "#a6b8ff40"
    },
    "description": "The 3 px soft ring around a focused text field, select or textarea, outside its accent edge."
  },
  "color.motion": {
    "css": "--motion",
    "tier": "semantic",
    "type": "color",
    "value": {
      "dark": "#6fcde0",
      "light": "#05718a",
      "high-contrast": "#4ccce6"
    },
    "description": "The working hue under the name of what it means: cyan is moving now and nothing else, so the Prism ray's sky end never doubles as working. A static mark of work in flight only; animated elements stay neutral (motion/status-hue)."
  },
  "pill.height": {
    "css": "--pill-height",
    "tier": "component",
    "type": "dimension",
    "value": "20px"
  },
  "pill.height-md": {
    "css": "--pill-height-md",
    "tier": "component",
    "type": "dimension",
    "value": "24px"
  },
  "pill.padding-x": {
    "css": "--pill-padding-x",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "pill.gap": {
    "css": "--pill-gap",
    "tier": "component",
    "type": "dimension",
    "value": "4px"
  },
  "pill.radius": {
    "css": "--pill-radius",
    "tier": "component",
    "type": "dimension",
    "value": "9999px"
  },
  "pill.icon-size": {
    "css": "--pill-icon-size",
    "tier": "component",
    "type": "dimension",
    "value": "12px"
  },
  "icon.size": {
    "css": "--icon-size",
    "tier": "component",
    "type": "dimension",
    "value": "16px",
    "description": "Icons in rows, buttons, menus and nav."
  },
  "icon.size-sm": {
    "css": "--icon-size-sm",
    "tier": "component",
    "type": "dimension",
    "value": "12px",
    "description": "Icons inside pills and beside caption text."
  },
  "icon.size-lg": {
    "css": "--icon-size-lg",
    "tier": "component",
    "type": "dimension",
    "value": "20px",
    "description": "File-type icons, page header icons."
  },
  "icon.size-empty": {
    "css": "--icon-size-empty",
    "tier": "component",
    "type": "dimension",
    "value": "32px",
    "description": "The one icon in an empty state."
  },
  "icon.stroke": {
    "css": "--icon-stroke",
    "tier": "component",
    "type": "number",
    "value": "1.75",
    "description": "Lucide stroke width at 16 px."
  },
  "metric.padding": {
    "css": "--metric-padding",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    }
  },
  "metric.radius": {
    "css": "--metric-radius",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "metric.value-size": {
    "css": "--metric-value-size",
    "tier": "component",
    "type": "dimension",
    "value": "28px"
  },
  "metric.value-line": {
    "css": "--metric-value-line",
    "tier": "component",
    "type": "dimension",
    "value": "32px"
  },
  "metric.sparkline-height": {
    "css": "--metric-sparkline-height",
    "tier": "component",
    "type": "dimension",
    "value": "28px"
  },
  "metric.stale-after": {
    "css": "--metric-stale-after",
    "tier": "component",
    "type": "duration",
    "value": "120000ms",
    "description": "Data older than this gets the stale warning (2 minutes)."
  },
  "meter.track-height": {
    "css": "--meter-track-height",
    "tier": "component",
    "type": "dimension",
    "value": "6px"
  },
  "meter.radius": {
    "css": "--meter-radius",
    "tier": "component",
    "type": "dimension",
    "value": "9999px"
  },
  "meter.track": {
    "css": "--meter-track",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#202227",
      "light": "#e7e9ee",
      "high-contrast": "#2e3135"
    }
  },
  "meter.fill": {
    "css": "--meter-fill",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#789bff",
      "light": "#3a5fe6",
      "high-contrast": "#a6b8ff"
    }
  },
  "meter.fill-image": {
    "css": "--meter-fill-image",
    "tier": "component",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(90deg, #6a8ef6 0%, #80aef7 100%)",
      "light": "linear-gradient(90deg, #2f4fc8 0%, #2f6ad6 100%)",
      "high-contrast": "linear-gradient(100deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "An ok fill: the Prism progress ray over the solid fill. Warn and over stay solid status colours."
  },
  "meter.fill-warn": {
    "css": "--meter-fill-warn",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#efc46a",
      "light": "#915b02",
      "high-contrast": "#ffca16"
    }
  },
  "meter.fill-over": {
    "css": "--meter-fill-over",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#f29c97",
      "light": "#c7232b",
      "high-contrast": "#ff9592"
    }
  },
  "meter.warn-at": {
    "css": "--meter-warn-at",
    "tier": "component",
    "type": "number",
    "value": "0.8",
    "description": "Fraction of budget where the fill turns amber."
  },
  "button.radius": {
    "css": "--button-radius",
    "tier": "component",
    "type": "dimension",
    "value": "6px"
  },
  "button.height": {
    "css": "--button-height",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "32px",
      "compact": "28px"
    }
  },
  "button.primary-bg": {
    "css": "--button-primary-bg",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#3465e4",
      "light": "#2c5bdc",
      "high-contrast": "#a6b8ff"
    },
    "description": "The solid under the primary's gradient (what forced colours keep): the control gradient at its middle."
  },
  "button.primary-image": {
    "css": "--button-primary-image",
    "tier": "component",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #2c6ae8 0%, #3c5fdf 100%)",
      "light": "linear-gradient(180deg, #2862e2 0%, #3053d5 100%)",
      "high-contrast": "linear-gradient(180deg, #a6b8ff 0%, #a6b8ff 100%)"
    },
    "description": "The primary's fill: the control gradient, blue into royal top to bottom, one hue (never the multicolour Prism ray)."
  },
  "button.primary-image-hover": {
    "css": "--button-primary-image-hover",
    "tier": "component",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #326feb 0%, #4264e3 100%)",
      "light": "linear-gradient(180deg, #3368e6 0%, #3659d9 100%)",
      "high-contrast": "linear-gradient(180deg, #cbd5ff 0%, #cbd5ff 100%)"
    },
    "description": "Hover: the same gradient one step brighter."
  },
  "button.primary-image-active": {
    "css": "--button-primary-image-active",
    "tier": "component",
    "type": "gradient",
    "value": {
      "dark": "linear-gradient(180deg, #2660df 0%, #3454d5 100%)",
      "light": "linear-gradient(180deg, #2558d0 0%, #2d4abe 100%)",
      "high-contrast": "linear-gradient(180deg, #cbd5ff 0%, #cbd5ff 100%)"
    },
    "description": "Pressed: the same gradient one step deeper."
  },
  "button.primary-fg": {
    "css": "--button-primary-fg",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#ffffff",
      "light": "#ffffff",
      "high-contrast": "#000000"
    }
  },
  "input.height": {
    "css": "--input-height",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "32px",
      "compact": "28px"
    }
  },
  "input.border": {
    "css": "--input-border",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#6a6e78",
      "light": "#7c808a",
      "high-contrast": "#8e929a"
    }
  },
  "input.border-hover": {
    "css": "--input-border-hover",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#878b95",
      "light": "#5d616b",
      "high-contrast": "#ced1d6"
    }
  },
  "input.radius": {
    "css": "--input-radius",
    "tier": "component",
    "type": "dimension",
    "value": "6px"
  },
  "input.ring": {
    "css": "--input-ring",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#789bff40",
      "light": "#3a5fe640",
      "high-contrast": "#a6b8ff40"
    },
    "description": "Focus: the accent edge plus this 3 px soft ring."
  },
  "input.ring-width": {
    "css": "--input-ring-width",
    "tier": "component",
    "type": "dimension",
    "value": "3px"
  },
  "checkbox.size": {
    "css": "--checkbox-size",
    "tier": "component",
    "type": "dimension",
    "value": "16px"
  },
  "checkbox.radius": {
    "css": "--checkbox-radius",
    "tier": "component",
    "type": "dimension",
    "value": "4px",
    "description": "A 16 px box takes a 4 px corner: the control radius would make it read as a radio."
  },
  "list-row.height": {
    "css": "--list-row-height",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "40px",
      "compact": "32px"
    }
  },
  "list-row.padding-x": {
    "css": "--list-row-padding-x",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    }
  },
  "list-row.gap": {
    "css": "--list-row-gap",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "16px",
      "compact": "12px"
    }
  },
  "list-row.hover": {
    "css": "--list-row-hover",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#18191e",
      "light": "#eef0f4",
      "high-contrast": "#212225"
    }
  },
  "list-row.selected": {
    "css": "--list-row-selected",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#202227",
      "light": "#e7e9ee",
      "high-contrast": "#2e3135"
    }
  },
  "list-row.highlight": {
    "css": "--list-row-highlight",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#789bff29",
      "light": "#3a5fe629",
      "high-contrast": "#a6b8ff29"
    }
  },
  "list-row.highlight-duration": {
    "css": "--list-row-highlight-duration",
    "tier": "component",
    "type": "duration",
    "value": "600ms"
  },
  "list-row.max-chips": {
    "css": "--list-row-max-chips",
    "tier": "component",
    "type": "number",
    "value": "1",
    "description": "At most one tag chip per row besides the plain status; more becomes a +N count."
  },
  "list-row.max-meta": {
    "css": "--list-row-max-meta",
    "tier": "component",
    "type": "number",
    "value": "2",
    "description": "At most two meta facts after the title."
  },
  "group-header.height": {
    "css": "--group-header-height",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "40px",
      "compact": "32px"
    },
    "description": "Same height as the rows it groups."
  },
  "drawer.width": {
    "css": "--drawer-width",
    "tier": "component",
    "type": "dimension",
    "value": "480px",
    "description": "Inspecting an item."
  },
  "drawer.width-wide": {
    "css": "--drawer-width-wide",
    "tier": "component",
    "type": "dimension",
    "value": "640px",
    "description": "Editing, diffs, AI review, spec import. Never more than 50vw on desktop."
  },
  "drawer.padding": {
    "css": "--drawer-padding",
    "tier": "component",
    "type": "dimension",
    "value": {
      "comfortable": "24px",
      "compact": "16px"
    }
  },
  "drawer.radius": {
    "css": "--drawer-radius",
    "tier": "component",
    "type": "dimension",
    "value": "12px"
  },
  "dialog.width-sm": {
    "css": "--dialog-width-sm",
    "tier": "component",
    "type": "dimension",
    "value": "440px",
    "description": "Alert dialogs (irreversible confirmations)."
  },
  "dialog.width": {
    "css": "--dialog-width",
    "tier": "component",
    "type": "dimension",
    "value": "560px",
    "description": "Default dialog: a form of 5 fields or fewer."
  },
  "dialog.width-lg": {
    "css": "--dialog-width-lg",
    "tier": "component",
    "type": "dimension",
    "value": "720px",
    "description": "Largest dialog. Anything bigger is a drawer or a page."
  },
  "dialog.padding": {
    "css": "--dialog-padding",
    "tier": "component",
    "type": "dimension",
    "value": "24px"
  },
  "dialog.radius": {
    "css": "--dialog-radius",
    "tier": "component",
    "type": "dimension",
    "value": "12px"
  },
  "popover.min-width": {
    "css": "--popover-min-width",
    "tier": "component",
    "type": "dimension",
    "value": "240px"
  },
  "popover.max-width": {
    "css": "--popover-max-width",
    "tier": "component",
    "type": "dimension",
    "value": "360px"
  },
  "popover.padding": {
    "css": "--popover-padding",
    "tier": "component",
    "type": "dimension",
    "value": "4px"
  },
  "popover.radius": {
    "css": "--popover-radius",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "board.column-width": {
    "css": "--board-column-width",
    "tier": "component",
    "type": "dimension",
    "value": "296px"
  },
  "board.column-min": {
    "css": "--board-column-min",
    "tier": "component",
    "type": "dimension",
    "value": "272px"
  },
  "board.column-max": {
    "css": "--board-column-max",
    "tier": "component",
    "type": "dimension",
    "value": "360px"
  },
  "board.column-gap": {
    "css": "--board-column-gap",
    "tier": "component",
    "type": "dimension",
    "value": "12px"
  },
  "board.column-bg": {
    "css": "--board-column-bg",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#0a0b0d",
      "light": "#f2f3f6",
      "high-contrast": "#000000"
    }
  },
  "board.card-padding": {
    "css": "--board-card-padding",
    "tier": "component",
    "type": "dimension",
    "value": "12px"
  },
  "board.card-gap": {
    "css": "--board-card-gap",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "attachment.thumb": {
    "css": "--attachment-thumb",
    "tier": "component",
    "type": "dimension",
    "value": "96px",
    "description": "Thumbnail in a drawer."
  },
  "attachment.thumb-lg": {
    "css": "--attachment-thumb-lg",
    "tier": "component",
    "type": "dimension",
    "value": "160px",
    "description": "Thumbnail in a detail page grid."
  },
  "attachment.gap": {
    "css": "--attachment-gap",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "attachment.radius": {
    "css": "--attachment-radius",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "toast.width": {
    "css": "--toast-width",
    "tier": "component",
    "type": "dimension",
    "value": "360px"
  },
  "toast.duration": {
    "css": "--toast-duration",
    "tier": "component",
    "type": "duration",
    "value": "5000ms",
    "description": "Info and success toasts. Paused on hover, focus and window blur."
  },
  "toast.duration-action": {
    "css": "--toast-duration-action",
    "tier": "component",
    "type": "duration",
    "value": "10000ms",
    "description": "Toasts with an action (Undo)."
  },
  "toast.max-visible": {
    "css": "--toast-max-visible",
    "tier": "component",
    "type": "number",
    "value": "3"
  },
  "tooltip.delay": {
    "css": "--tooltip-delay",
    "tier": "component",
    "type": "duration",
    "value": "400ms",
    "description": "Hover delay. Focus opens at once."
  },
  "tooltip.skip-delay": {
    "css": "--tooltip-skip-delay",
    "tier": "component",
    "type": "duration",
    "value": "300ms"
  },
  "hovercard.open-delay": {
    "css": "--hovercard-open-delay",
    "tier": "component",
    "type": "duration",
    "value": "500ms"
  },
  "hovercard.close-delay": {
    "css": "--hovercard-close-delay",
    "tier": "component",
    "type": "duration",
    "value": "200ms"
  },
  "skeleton.show-after": {
    "css": "--skeleton-show-after",
    "tier": "component",
    "type": "duration",
    "value": "200ms",
    "description": "Show a skeleton only if loading takes longer than this."
  },
  "skeleton.min-visible": {
    "css": "--skeleton-min-visible",
    "tier": "component",
    "type": "duration",
    "value": "400ms",
    "description": "Once shown, keep it at least this long to avoid a flash."
  },
  "stage.min-width": {
    "css": "--stage-min-width",
    "tier": "component",
    "type": "dimension",
    "value": "168px"
  },
  "stage.radius": {
    "css": "--stage-radius",
    "tier": "component",
    "type": "dimension",
    "value": "8px"
  },
  "stage.connector": {
    "css": "--stage-connector",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#2c2f36",
      "light": "#cbced6",
      "high-contrast": "#ced1d6"
    }
  },
  "audit.rail": {
    "css": "--audit-rail",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#1f2125",
      "light": "#e1e4ea",
      "high-contrast": "#8e929a"
    }
  },
  "audit.hash-font": {
    "css": "--audit-hash-font",
    "tier": "component",
    "type": "fontFamily",
    "value": "'JetBrains Mono Variable', 'JetBrains Mono', 'Cascadia Code', ui-monospace, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace"
  },
  "focus-ring.width": {
    "css": "--focus-ring-width",
    "tier": "component",
    "type": "dimension",
    "value": "2px"
  },
  "focus-ring.offset": {
    "css": "--focus-ring-offset",
    "tier": "component",
    "type": "dimension",
    "value": "2px"
  },
  "focus-ring.color": {
    "css": "--focus-ring-color",
    "tier": "component",
    "type": "color",
    "value": {
      "dark": "#8b93f8",
      "light": "#4b53d6",
      "high-contrast": "#ffd60a"
    }
  },
  "live-room.col.project": {
    "css": "--live-room-col-project",
    "tier": "component",
    "type": "dimension",
    "value": "10rem",
    "description": "Project and lane label column."
  },
  "live-room.col.mission": {
    "css": "--live-room-col-mission",
    "tier": "component",
    "type": "dimension",
    "value": "14rem",
    "description": "Mission column (hidden in unlinked mode, which gives its width to Agents)."
  },
  "live-room.col.agents": {
    "css": "--live-room-col-agents",
    "tier": "component",
    "type": "dimension",
    "value": "24rem",
    "description": "Agents column minimum; it takes the remaining width."
  },
  "live-room.col.pipeline": {
    "css": "--live-room-col-pipeline",
    "tier": "component",
    "type": "dimension",
    "value": "14rem",
    "description": "Pipeline column: the stage track."
  },
  "live-room.col.landed": {
    "css": "--live-room-col-landed",
    "tier": "component",
    "type": "dimension",
    "value": "6rem",
    "description": "Landed count column."
  },
  "instrument.h.glance": {
    "css": "--instrument-h-glance",
    "tier": "component",
    "type": "dimension",
    "value": "104px",
    "description": "A glance strip cell (cell 0 is always Needs you)."
  },
  "instrument.h.hero": {
    "css": "--instrument-h-hero",
    "tier": "component",
    "type": "dimension",
    "value": "360px",
    "description": "The one hero instrument of a lens."
  },
  "instrument.h.support": {
    "css": "--instrument-h-support",
    "tier": "component",
    "type": "dimension",
    "value": "280px",
    "description": "Supporting instruments under the hero."
  },
  "live.stale-after": {
    "css": "--live-stale-after",
    "tier": "component",
    "type": "duration",
    "value": "120000ms",
    "description": "A row with no data for this long reads Stale in neutral (a muted clock icon from 2 min)."
  },
  "live.recap-away": {
    "css": "--live-recap-away",
    "tier": "component",
    "type": "duration",
    "value": "600000ms",
    "description": "Away longer than this (Page Visibility) and the page offers a While you were away recap."
  },
  "live.line-min-dwell": {
    "css": "--live-line-min-dwell",
    "tier": "component",
    "type": "duration",
    "value": "2000ms",
    "description": "An activity line stays at least this long before the next one crossfades in."
  },
  "live.wall.cut-min": {
    "css": "--live-wall-cut-min",
    "tier": "component",
    "type": "duration",
    "value": "15000ms",
    "description": "The wall director holds a spotlight at least this long."
  },
  "live.wall.hold-release": {
    "css": "--live-wall-hold-release",
    "tier": "component",
    "type": "duration",
    "value": "10000ms",
    "description": "Held changes on the wall release every this often."
  },
  "live.wall.shift-interval": {
    "css": "--live-wall-shift-interval",
    "tier": "component",
    "type": "duration",
    "value": "180000ms",
    "description": "Burn-in shift (M15): the board moves by shift every this often."
  },
  "live.wall.shift": {
    "css": "--live-wall-shift",
    "tier": "component",
    "type": "dimension",
    "value": "2px",
    "description": "Burn-in shift distance."
  },
  "live.budget.animations": {
    "css": "--live-budget-animations",
    "tier": "component",
    "type": "number",
    "value": "40",
    "description": "Hard cap of running animations per viewport (document.getAnimations())."
  },
  "live.budget.animations-calm": {
    "css": "--live-budget-animations-calm",
    "tier": "component",
    "type": "number",
    "value": "30",
    "description": "Cap on Overview."
  },
  "live.budget.flow-dots": {
    "css": "--live-budget-flow-dots",
    "tier": "component",
    "type": "number",
    "value": "24",
    "description": "Flow dots in flight per viewport; over budget new dots are dropped, never queued."
  },
  "live.budget.flow-dots-wall": {
    "css": "--live-budget-flow-dots-wall",
    "tier": "component",
    "type": "number",
    "value": "40",
    "description": "Flow dots in flight on the wall."
  },
  "live.budget.flow-dots-per-edge": {
    "css": "--live-budget-flow-dots-per-edge",
    "tier": "component",
    "type": "number",
    "value": "3",
    "description": "Flow dots in flight on one edge."
  },
  "live.budget.spinners-per-group": {
    "css": "--live-budget-spinners-per-group",
    "tier": "component",
    "type": "number",
    "value": "8",
    "description": "Past this many working rows a group spins only its header icon; rows show a static ring."
  }
} as const;

/** Primitive values, for documentation only. Components never use these. */
export const PRIMITIVES = {
  "color.gray.0": "#ffffff",
  "color.gray.1000": "#000000",
  "color.neutral.dark.1": "#111113",
  "color.neutral.dark.2": "#18191b",
  "color.neutral.dark.3": "#212225",
  "color.neutral.dark.4": "#272a2d",
  "color.neutral.dark.5": "#2e3135",
  "color.neutral.dark.6": "#363a3f",
  "color.neutral.dark.7": "#43484e",
  "color.neutral.dark.8": "#5a6169",
  "color.neutral.dark.9": "#696e77",
  "color.neutral.dark.10": "#777b84",
  "color.neutral.dark.11": "#b0b4ba",
  "color.neutral.dark.12": "#edeef0",
  "color.neutral.dark.overlay": "#1e1f22",
  "color.neutral.dark.text-2": "#b9bec6",
  "color.neutral.dark.text-3": "#8e929a",
  "color.neutral.dark.control": "#676c74",
  "color.neutral.light.1": "#fcfcfd",
  "color.neutral.light.2": "#f9f9fb",
  "color.neutral.light.3": "#f0f0f3",
  "color.neutral.light.4": "#e8e8ec",
  "color.neutral.light.5": "#e0e1e6",
  "color.neutral.light.6": "#d9d9e0",
  "color.neutral.light.7": "#cdced6",
  "color.neutral.light.8": "#b9bbc6",
  "color.neutral.light.9": "#8b8d98",
  "color.neutral.light.10": "#80838d",
  "color.neutral.light.11": "#60646c",
  "color.neutral.light.12": "#1c2024",
  "color.neutral.light.text-2": "#51555d",
  "color.neutral.light.text-3": "#656971",
  "color.neutral.light.control": "#83868f",
  "color.neutral.hc.panel": "#0c0c0e",
  "color.neutral.hc.text-2": "#dbdee3",
  "color.neutral.hc.text-3": "#ced1d6",
  "color.neutral.hc.line": "#7c8088",
  "color.neutral.hc.control": "#8e929a",
  "color.neutral.night.0": "#0a0b0d",
  "color.neutral.night.1": "#0a0b0d",
  "color.neutral.night.2": "#121317",
  "color.neutral.night.3": "#1a1b20",
  "color.neutral.night.4": "#202227",
  "color.neutral.night.5": "#24262c",
  "color.neutral.night.6": "#2c2f36",
  "color.neutral.night.7": "#383b43",
  "color.neutral.night.8": "#4d515a",
  "color.neutral.night.9": "#62666f",
  "color.neutral.night.10": "#757a84",
  "color.neutral.night.11": "#a3a8b1",
  "color.neutral.night.12": "#dfe1e6",
  "color.neutral.night.hover": "#18191e",
  "color.neutral.night.line-subtle": "#191a1e",
  "color.neutral.night.line": "#1f2125",
  "color.neutral.night.text-2": "#a3a8b1",
  "color.neutral.night.text-3": "#878b95",
  "color.neutral.night.control": "#6a6e78",
  "color.neutral.mist.canvas": "#f3f4f7",
  "color.neutral.mist.hover": "#eef0f4",
  "color.neutral.mist.active": "#e7e9ee",
  "color.neutral.mist.sunken": "#f2f3f6",
  "color.neutral.mist.line-subtle": "#ebedf1",
  "color.neutral.mist.line": "#e1e4ea",
  "color.neutral.mist.strong": "#cbced6",
  "color.neutral.mist.faint": "#b3b7c0",
  "color.neutral.mist.text-1": "#1e2229",
  "color.neutral.mist.text-2": "#4b515c",
  "color.neutral.mist.text-3": "#5d616b",
  "color.neutral.mist.control": "#7c808a",
  "color.neutral.mist.rail": "#eceef2",
  "color.sapphire.100": "#cbd5ff",
  "color.sapphire.200": "#a6b8ff",
  "color.sapphire.300": "#93a9ff",
  "color.sapphire.500": "#4361ee",
  "color.sapphire.600": "#3a55e3",
  "color.sapphire.700": "#3249cf",
  "color.red.dark-3": "#3b1219",
  "color.red.dark-7": "#8c333a",
  "color.red.dark-11": "#ff9592",
  "color.red.dark-12": "#ffd1d9",
  "color.red.light-3": "#feebec",
  "color.red.light-7": "#f4a9aa",
  "color.red.light-11": "#c7232b",
  "color.red.light-12": "#641723",
  "color.amber.dark-3": "#302008",
  "color.amber.dark-7": "#714f19",
  "color.amber.dark-11": "#ffca16",
  "color.amber.dark-12": "#ffe7b3",
  "color.amber.light-3": "#fff7c2",
  "color.amber.light-7": "#e9c162",
  "color.amber.light-11": "#915b02",
  "color.amber.light-12": "#4f3422",
  "color.green.dark-3": "#132d21",
  "color.green.dark-7": "#28684a",
  "color.green.dark-11": "#3dd68c",
  "color.green.dark-12": "#b1f1cb",
  "color.green.light-3": "#e6f6eb",
  "color.green.light-7": "#8eceaa",
  "color.green.light-11": "#07764b",
  "color.green.light-12": "#193b2d",
  "color.cyan.dark-3": "#082c36",
  "color.cyan.dark-7": "#12677e",
  "color.cyan.dark-11": "#4ccce6",
  "color.cyan.dark-12": "#b6ecf7",
  "color.cyan.light-3": "#def7f9",
  "color.cyan.light-7": "#7dcedc",
  "color.cyan.light-11": "#05718a",
  "color.cyan.light-12": "#0d3c48",
  "color.yellow.300": "#ffd60a",
  "color.categorical.light.1": "#344ece",
  "color.categorical.light.2": "#784005",
  "color.categorical.light.3": "#055b4e",
  "color.categorical.light.4": "#ba1f77",
  "color.categorical.light.5": "#118ab2",
  "color.categorical.light.6": "#dd5705",
  "color.categorical.light.7": "#7c6d08",
  "color.categorical.light.8": "#864bd3",
  "color.categorical.dark.1": "#6686fd",
  "color.categorical.dark.2": "#fea76b",
  "color.categorical.dark.3": "#0edabe",
  "color.categorical.dark.4": "#feaff4",
  "color.categorical.dark.5": "#03afcf",
  "color.categorical.dark.6": "#f8554d",
  "color.categorical.dark.7": "#9f9600",
  "color.categorical.dark.8": "#cc86fe",
  "color.alpha.black-28": "#00000047",
  "color.alpha.black-35": "#00000059",
  "color.alpha.black-40": "#00000066",
  "color.alpha.black-45": "#00000073",
  "color.alpha.black-55": "#0000008c",
  "color.alpha.black-80": "#000000cc",
  "color.alpha.white-04": "#ffffff0a",
  "color.alpha.white-06": "#ffffff0f",
  "color.alpha.white-24": "#ffffff3d",
  "color.alpha.white-60": "#ffffff99",
  "color.alpha.ink-04": "#1010180a",
  "color.alpha.ink-06": "#1010180f",
  "color.alpha.ink-08": "#10101814",
  "color.alpha.ink-10": "#1010181a",
  "color.alpha.ink-16": "#10101829",
  "color.alpha.backdrop-dark": "#0404069e",
  "color.alpha.backdrop-light": "#14141c52",
  "color.alpha.backdrop-hc": "#000000c7",
  "color.alpha.transparent": "#00000000",
  "color.soft.dark.working": "#6fcde0",
  "color.soft.dark.attention": "#efc46a",
  "color.soft.dark.success": "#73cf9d",
  "color.soft.dark.danger": "#f29c97",
  "color.soft.dark.data-1": "#7e97f1",
  "color.soft.dark.data-2": "#f9b787",
  "color.soft.dark.data-3": "#83ecd9",
  "color.soft.dark.data-4": "#d990c0",
  "color.soft.dark.data-5": "#71cae7",
  "color.soft.dark.data-6": "#f28f85",
  "color.soft.dark.data-7": "#d6c25a",
  "color.soft.dark.data-8": "#bd8ff5",
  "color.soft.light.working": "#5bb8cc",
  "color.soft.light.attention": "#e6b24a",
  "color.soft.light.success": "#5fb886",
  "color.soft.light.danger": "#e57f79",
  "color.soft.light.data-1": "#3354b6",
  "color.soft.light.data-2": "#d17c3c",
  "color.soft.light.data-3": "#2b9c88",
  "color.soft.light.data-4": "#b24f94",
  "color.soft.light.data-5": "#2079a9",
  "color.soft.light.data-6": "#c3463c",
  "color.soft.light.data-7": "#9a8628",
  "color.soft.light.data-8": "#8d6bd6",
  "color.prism.1": "#4e98ff",
  "color.prism.2": "#38c4ea",
  "color.prism.3": "#f6ae5f",
  "color.prism.4": "#ee8350",
  "color.prism.5": "#5160ee",
  "color.prism.6": "#3e6cf4",
  "color.prism.shade": "#0b1020",
  "color.prism-blue.200": "#94b6ff",
  "color.prism-blue.300": "#8aa9ff",
  "color.prism-blue.400": "#789bff",
  "color.prism-blue.450": "#6a8ef6",
  "color.prism-blue.500": "#3a5fe6",
  "color.prism-blue.600": "#3456d8",
  "color.prism-blue.650": "#2f5ad6",
  "color.prism-blue.700": "#2f4fc8",
  "color.prism-blue.ink": "#08111f",
  "color.prism-indigo.300": "#8b93f8",
  "color.prism-indigo.600": "#4b53d6",
  "color.control-blue.dark.from": "#2c6ae8",
  "color.control-blue.dark.to": "#3c5fdf",
  "color.control-blue.dark.from-hover": "#326feb",
  "color.control-blue.dark.to-hover": "#4264e3",
  "color.control-blue.dark.from-active": "#2660df",
  "color.control-blue.dark.to-active": "#3454d5",
  "color.control-blue.dark.mid": "#3465e4",
  "color.control-blue.dark.line": "#5683f2",
  "color.control-blue.light.from": "#2862e2",
  "color.control-blue.light.to": "#3053d5",
  "color.control-blue.light.from-hover": "#3368e6",
  "color.control-blue.light.to-hover": "#3659d9",
  "color.control-blue.light.from-active": "#2558d0",
  "color.control-blue.light.to-active": "#2d4abe",
  "color.control-blue.light.mid": "#2c5bdc",
  "color.prism-ray.dark.from": "#9c9afc",
  "color.prism-ray.dark.from-hover": "#aaa8ff",
  "color.prism-ray.dark.from-active": "#8d8bf0",
  "color.prism-ray.dark.mid": "#7f98ff",
  "color.prism-ray.dark.mid-hover": "#8fa6ff",
  "color.prism-ray.dark.mid-active": "#7088f2",
  "color.prism-ray.dark.to": "#7ab2f0",
  "color.prism-ray.dark.to-hover": "#8cc0f4",
  "color.prism-ray.dark.to-active": "#69a3e2",
  "color.prism-ray.dark.warm": "#f1aa7c",
  "color.prism-ray.dark.warm-hover": "#f4b98f",
  "color.prism-ray.dark.warm-active": "#e89a6e",
  "color.prism-ray.dark.end": "#ee9a6e",
  "color.prism-ray.dark.end-hover": "#f1aa80",
  "color.prism-ray.dark.end-active": "#e48d60",
  "color.prism-ray.dark.progress-from": "#6a8ef6",
  "color.prism-ray.dark.progress-to": "#80aef7",
  "color.prism-ray.dark.headline-mid": "#aaa6f8",
  "color.prism-ray.dark.headline-warm": "#f2a27a",
  "color.prism-ray.dark.warm-from": "#f2bb9c",
  "color.prism-ray.dark.warm-to": "#ec9f78",
  "color.prism-ray.dark.new-fg": "#241205",
  "color.prism-ray.light.from": "#5148d8",
  "color.prism-ray.light.from-hover": "#4339c6",
  "color.prism-ray.light.from-active": "#3a31b0",
  "color.prism-ray.light.mid": "#3d5ce4",
  "color.prism-ray.light.mid-hover": "#3049c8",
  "color.prism-ray.light.mid-active": "#2a40b0",
  "color.prism-ray.light.to": "#2367c6",
  "color.prism-ray.light.to-hover": "#1a58ab",
  "color.prism-ray.light.to-active": "#164c94",
  "color.prism-ray.light.warm": "#b84d10",
  "color.prism-ray.light.warm-hover": "#a8440a",
  "color.prism-ray.light.warm-active": "#93390a",
  "color.prism-ray.light.end": "#b04a0e",
  "color.prism-ray.light.end-hover": "#9c3f0a",
  "color.prism-ray.light.end-active": "#8a3609",
  "color.prism-ray.light.progress-from": "#2f4fc8",
  "color.prism-ray.light.progress-to": "#2f6ad6",
  "color.prism-ray.light.new-from": "#fbdccb",
  "color.prism-ray.light.new-to": "#f8d2bd",
  "color.prism-ray.light.new-fg": "#6a3517",
  "color.prism-ray.light.headline-mid": "#5a48d6",
  "color.prism-ray.light.headline-warm": "#b94a0c",
  "dimension.0": "0px",
  "dimension.1": "1px",
  "dimension.2": "2px",
  "dimension.4": "4px",
  "dimension.6": "6px",
  "dimension.8": "8px",
  "dimension.10": "10px",
  "dimension.11": "11px",
  "dimension.12": "12px",
  "dimension.13": "13px",
  "dimension.14": "14px",
  "dimension.15": "15px",
  "dimension.16": "16px",
  "dimension.18": "18px",
  "dimension.20": "20px",
  "dimension.22": "22px",
  "dimension.24": "24px",
  "dimension.28": "28px",
  "dimension.32": "32px",
  "dimension.36": "36px",
  "dimension.40": "40px",
  "dimension.44": "44px",
  "dimension.48": "48px",
  "dimension.56": "56px",
  "dimension.64": "64px",
  "dimension.72": "72px",
  "dimension.80": "80px",
  "dimension.96": "96px",
  "dimension.104": "104px",
  "dimension.120": "120px",
  "dimension.128": "128px",
  "dimension.160": "160px",
  "dimension.224": "224px",
  "dimension.240": "240px",
  "dimension.272": "272px",
  "dimension.296": "296px",
  "dimension.360": "360px",
  "dimension.400": "400px",
  "dimension.440": "440px",
  "dimension.480": "480px",
  "dimension.560": "560px",
  "dimension.640": "640px",
  "dimension.720": "720px",
  "dimension.1200": "1200px",
  "dimension.1584": "1584px",
  "dimension.full": "9999px",
  "duration.0": "0ms",
  "duration.120": "120ms",
  "duration.200": "200ms",
  "duration.320": "320ms",
  "duration.400": "400ms",
  "duration.600": "600ms",
  "duration.800": "800ms",
  "duration.1000": "1000ms",
  "duration.1200": "1200ms",
  "duration.1600": "1600ms",
  "curve.expo-out": "cubic-bezier(0.16, 1, 0.3, 1)",
  "curve.in-out": "cubic-bezier(0.65, 0, 0.35, 1)",
  "curve.linear": "linear",
  "curve.settle": "linear(0, 0.0229, 0.0789, 0.1534, 0.2364, 0.3211, 0.4034, 0.4806, 0.5514, 0.615, 0.6715, 0.7211, 0.7642, 0.8014, 0.8332, 0.8604, 0.8835, 0.903, 0.9194, 0.9331, 0.9447, 0.9543, 0.9623, 0.9689, 0.9744, 0.979, 0.9828, 0.9859, 0.9884, 0.9905, 0.9923, 0.9937, 0.9948, 0.9958, 0.9966, 0.9972, 0.9977, 0.9981, 0.9985, 0.9988, 1)",
  "font-family.inter": "'Inter Variable', 'Inter Fallback', 'Segoe UI Variable Text', 'Segoe UI', system-ui, -apple-system, 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'Arial', sans-serif",
  "font-family.inter-display": "'Inter Variable', 'Inter Display Fallback', 'Inter Fallback', 'Segoe UI Variable Display', 'Segoe UI', system-ui, -apple-system, 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'Arial', sans-serif",
  "font-family.jetbrains-mono": "'JetBrains Mono Variable', 'JetBrains Mono', 'Cascadia Code', ui-monospace, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace",
  "font-weight.400": "400",
  "font-weight.500": "500",
  "font-weight.600": "600",
  "ratio.line-loose": "1.5",
  "ratio.line-snug": "1.333",
  "ratio.line-tight": "1.25"
} as const;

/** Tokens v0 CSS names and the v1 variable (or value) each now points to. */
export const LEGACY = {
  "--st-working": "--status-working",
  "--st-waiting": "--status-attention",
  "--st-idle": "--status-muted",
  "--st-ended": "--status-inactive",
  "--st-passed": "--status-success",
  "--st-failed": "--status-danger",
  "--st-queued": "--status-pending",
  "--st-offline": "--status-muted",
  "--st-working-soft": "--status-working-soft",
  "--st-waiting-soft": "--status-attention-soft",
  "--st-idle-soft": "--status-muted-soft",
  "--st-ended-soft": "--status-inactive-soft",
  "--st-passed-soft": "--status-success-soft",
  "--st-failed-soft": "--status-danger-soft",
  "--st-queued-soft": "--status-pending-soft",
  "--st-offline-soft": "--status-muted-soft",
  "--hue-1": "--data-1",
  "--hue-2": "--data-2",
  "--hue-3": "--data-3",
  "--hue-4": "--data-4",
  "--hue-5": "--data-5",
  "--hue-6": "--data-6",
  "--hue-7": "--data-7",
  "--hue-8": "--data-8",
  "--sh-sm": "--elevation-flat",
  "--sh-md": "--elevation-1",
  "--sh-lg": "--elevation-2",
  "--sh-overlay": "--elevation-3",
  "--inset-highlight": "--elevation-highlight",
  "--space-5": "20px",
  "--rail-w": "--layout-rail-width",
  "--rail-w-collapsed": "--layout-rail-width-collapsed",
  "--topbar-h": "--layout-topbar-height",
  "--dur-instant": "--duration-fast",
  "--dur-fast": "--duration-fast",
  "--dur": "--duration-base",
  "--dur-slow": "--duration-slow",
  "--ease-out": "--easing-standard",
  "--ease-in-out": "--easing-emphasized",
  "--ease-spring": "--easing-standard"
} as const;
